import script from "./StockDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./StockDetail.vue?vue&type=script&lang=ts&setup=true"

import "./StockDetail.vue?vue&type=style&index=0&id=6f85bd58&lang=scss"
import "./StockDetail.vue?vue&type=style&index=1&id=6f85bd58&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f85bd58"]])

export default __exports__